module.exports = __webpack_public_path__ + "static/img/6.12e0d14b.jpg";